const SEGMENT_POSTPAID = 'POSTPAID';
const SEGMENT_PREPAID = 'PREPAID';
const SEGMENT_HYBRID = 'HYBRID';
const SEGMENT_OTHERS = 'OTHERS';
const SEGMENTS_ALL = [
  SEGMENT_POSTPAID,
  SEGMENT_PREPAID,
  SEGMENT_HYBRID,
  SEGMENT_OTHERS,
];
const SEGMENTS_NO_PREPAID = [SEGMENT_POSTPAID, SEGMENT_HYBRID, SEGMENT_OTHERS];
const SEGMENTS_NO_POSTPAID = [SEGMENT_PREPAID, SEGMENT_HYBRID, SEGMENT_OTHERS];

const PROFILES_BAM = ['BAM PREPAGO', 'BAM LIBRE', 'BAM CONTROL', 'BAM'];
const PROFILES_POSTPAID = [
  'POSTPAID_DATOSSMS',
  'POSTPAID_VOZSMS',
  'POSTPAID_LIBRE',
];
const PROFILES_HYBRID = [
  'HYBRID_SIMPLE',
  'HYBRID_ANTIGUO',
  'HYBRID_BUSINESS',
  'HYBRID_POSTPAID',
  'HYBRID_POSTPAID',
  'CONTROL_ANTIGUO',
];
const PROFILES_PREPAID = ['PREPAID'];
const PROFILES_NO_PREPAID = [
  ...PROFILES_BAM,
  ...PROFILES_POSTPAID,
  ...PROFILES_HYBRID,
];
const PROFILES_NO_BAM = [
  ...PROFILES_POSTPAID,
  ...PROFILES_HYBRID,
  ...PROFILES_PREPAID,
];
const PROFILES_ALL = [
  ...PROFILES_BAM,
  ...PROFILES_POSTPAID,
  ...PROFILES_HYBRID,
  ...PROFILES_PREPAID,
];

export {
  SEGMENT_POSTPAID,
  SEGMENT_PREPAID,
  SEGMENT_HYBRID,
  SEGMENT_OTHERS,
  SEGMENTS_ALL,
  SEGMENTS_NO_PREPAID,
  SEGMENTS_NO_POSTPAID,
  PROFILES_BAM,
  PROFILES_POSTPAID,
  PROFILES_HYBRID,
  PROFILES_PREPAID,
  PROFILES_ALL,
  PROFILES_NO_BAM,
  PROFILES_NO_PREPAID,
};
